// extracted by mini-css-extract-plugin
export default {"listingPage":"_3YREj-P","advert":"B1jL7hg"};